import { useCart } from '../../context/CartContext';
import './Cart.css';

const Cart = () => {
  const {
    cart,
    removeFromCart,
    updateQuantity,
    getCartTotal,
    isCartOpen,
    closeCart,
    clearCart
  } = useCart();

  if (!isCartOpen) return null;

  const totalQuantity = cart.reduce((sum, item) => sum + item.quantity, 0);
  const subTotal = getCartTotal();
  const deliveryCharge = subTotal > 5000 ? 0 : 50;
  const grandTotal = subTotal + deliveryCharge;

  const handleCheckout = () => {
    if (!cart.length) {
      alert('तपाईंको कार्ट खाली छ!');
      return;
    }

    alert('अर्डर सफलतापूर्वक राखियो! हाम्रो विक्रेता चाँडै नै तपाईंसँग सम्पर्क गर्नेछ।');
    clearCart();
    closeCart();
  };

  const getDisplayName = (item) => {
    const names = {
      '1': 'रोल्पा आलु (ठाडो पहाडी)',
      '2': 'मुस्ताङ आलु (अल्पाइन)',
      '3': 'तराई आलु (मैदानी)',
      '4': 'जुम्ला आलु (उच्च हिमाली)',
      '5': 'धनकुटा आलु (पूर्वाञ्चल)',
      '6': 'नेपाली प्याज (लालपुर)',
      '7': 'भारतीय प्याज (आयातित)',
      '8': 'हरियो प्याज',
      '9': 'नेपाली लसुन (घरेलु)',
      '10': 'चिनियाँ लसुन',
      '11': 'हिमाली लसुन',
      '12': 'इलाम अदुवा',
      '13': 'तराई अदुवा',
      '14': 'घरेलु अदुवा',
      '15': 'आलु–प्याज संग्रह',
      '16': 'लसुन–अदुवा संग्रह',
      '17': 'पूर्ण घरेलु संग्रह'
    };

    return names[item.id] || item.name;
  };

  return (
    <div className="cart-overlay" onClick={closeCart}>
      <div className="cart-box" onClick={(e) => e.stopPropagation()}>

        <div className="cart-header">
          <h2>🛒 तपाईंको कार्ट</h2>
          <button className="close-btn" onClick={closeCart}>×</button>
        </div>

        <div className="cart-summary">
          <span>वस्तु प्रकार: <strong>{cart.length}</strong></span>
          <span>कुल मात्रा: <strong>{totalQuantity} किलो</strong></span>
        </div>

        {cart.length === 0 ? (
          <div className="empty-cart">
            <span className="emoji">🛒</span>
            <p>तपाईंको कार्ट खाली छ</p>
            <small>कृपया उत्पादन थप्नुहोस्</small>
          </div>
        ) : (
          <>
            <div className="cart-items">
              {cart.map(item => (
                <div className="cart-item" key={item.id}>
                  <div className="item-info">
                    <h4>{getDisplayName(item)}</h4>
                    <span>₹{item.price}/किलो</span>
                  </div>

                  <div className="quantity-control">
                    <button onClick={() => updateQuantity(item.id, item.quantity - 1)}>−</button>
                    <span>{item.quantity} किलो</span>
                    <button onClick={() => updateQuantity(item.id, item.quantity + 1)}>+</button>
                  </div>

                  <div className="item-total">
                    ₹{item.price * item.quantity}
                  </div>

                  <button
                    className="remove-btn"
                    onClick={() => removeFromCart(item.id)}
                  >
                    🗑️
                  </button>
                </div>
              ))}
            </div>

            <div className="price-box">
              <div><span>उप–कुल</span><span>₹{subTotal}</span></div>
              <div><span>वितरण शुल्क</span><span>{deliveryCharge === 0 ? 'मुफ्त' : `₹${deliveryCharge}`}</span></div>
              <div className="grand-total">
                <span>जम्मा रकम</span>
                <span>₹{grandTotal}</span>
              </div>
            </div>

            <div className="cart-actions">
              <button className="secondary" onClick={closeCart}>खरिद जारी राख्नुहोस्</button>
              <button className="primary" onClick={handleCheckout}>अर्डर गर्नुहोस्</button>
            </div>

            <div className="cart-footer">
              <p>📞 सम्पर्क: ९८४९७५३५५७ / ९८५११९६०५६</p>
              <p>⏰ वितरण: २–४ घण्टा</p>
            </div>
          </>
        )}

      </div>
    </div>
  );
};

export default Cart;
